import { AdminMessages } from "../AdministrationMessages";
import { csrfToken } from "../communication/AjaxHelper";

export class SpritesheetData {

    zipFile: Uint8Array<ArrayBuffer>;

    async load(spritesheetIdOrURL: number | string, alertIfSpritesheetMissing: boolean = true): Promise<void> {
        if (spritesheetIdOrURL == null) return;

        if (typeof spritesheetIdOrURL == "number") {
            spritesheetIdOrURL = "sprites/" + ('0' + (spritesheetIdOrURL % 256).toString(16)).slice(-2).toUpperCase() + "/" + spritesheetIdOrURL + ".zip";
        }

        await this.loadFromServer(spritesheetIdOrURL, alertIfSpritesheetMissing);

        return;
    }

    private async loadFromServer(path: string, alertIfSpritesheetMissing: boolean = true): Promise<void> {

        let headers: { [key: string]: string; } = {};
        if (csrfToken != null) headers = { "x-token-pm": csrfToken };

        return new Promise((resolve, reject) => {
            jQuery.ajax({
                type: 'GET',
                async: true,
                url: path,
                headers: headers,
                xhrFields: { responseType: 'arraybuffer' },
                success: (arrayBuffer: ArrayBuffer) => {

                    this.zipFile = new Uint8Array(arrayBuffer);
                    resolve();

                },
                error: (jqXHR, message) => {
                    if (alertIfSpritesheetMissing) {
                        alert(AdminMessages.couldntLoadSpritesheet() + message);
                    }
                    reject();
                }
            });

        });

    }

}